import type { CompRef, DsItem } from '@wix/document-services-types';
import { PluginInterface } from '@wix/ambassador-app-service-webapp/types';
import type { PluginPlacement } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
import type { SlotScope } from '@wix/ambassador-document-v1-component/types';
import type { PluginInstallationSettings } from '@wix/ambassador-devcenter-components-v1-component/types';

export interface PluginInfo {
  widgetId: string;
  appDefinitionId: string;
  name: string;
  description: string;
  logoUrl: string;
}

export interface WidgetSlot {
  compRef: CompRef;
  interfaces?: string[];
  role: string;
  placement: PluginPlacement;
  pluginInfo?: PluginInfo;
}

export type WidgetPlugin = {
  id: string;
  appDefinitionId: string;
  name: string;
  description: string;
  widgetRefId: string;
  logoUrl: string | null;
  price: string;
  author: string;
  pluginInterfaces: string[]; // TODO remove when deprecated
  placements: PluginPlacement[];
  installation?: PluginInstallationSettings;
  slot?: WidgetSlot;
};

export type WidgetPointer = {
  appDefinitionId: string;
  widgetId: string;
};

export interface SlotData {
  widgetId: string;
  pageId: string;
  slotId: string;
  componentId: string;
  interfaces: PluginInterface[];
  scope?: SlotScope;
}

export interface EditorIntegrationAPI {
  isBlocks(): boolean;
  getWidgetPluginsRequest(params: {
    includeApps?: string[];
    placements?: PluginPlacement[];
  }): Promise<WidgetPlugin[]>;
  isWidgetPluginMoveActionEnabled(ref: CompRef): boolean;
  getWidgetSlots(ref: CompRef): WidgetSlot[];
  getSlotsData(ref: CompRef): Record<string, CompRef>;
  getWidgetSlotData(ref: CompRef): DsItem;
  installWidgetPlugin(
    ref: CompRef,
    widgetPointer: WidgetPointer,
  ): Promise<void>;
  uninstallWidgetPlugin(ref: CompRef): Promise<void>;
  openPanel(panelName: string, panelProps?: object, leaveOpen?: boolean): void;
  closeWidgetPluginsPanel(): void;
  highlightSlot(slotsPlaceholderCompRef: CompRef): Promise<void>;
  unhighlightSlot(slotsPlaceholderCompRef: CompRef): void;
  movePlugin(ref: CompRef): void;
}

export enum PluginsEditorType {
  Classic = 'classic',
  Responsive = 'editorx',
  Studio = 'studio',
  ADI = 'adi',
}
export type PluginsHostApiContext = {
  origin: string;
  editorType: PluginsEditorType;
};
